













import Vue, { VNode } from 'vue'

import {CopyToClipboard} from '../../../utilities/Clipboard'

export default Vue.extend({
    name: 'rd-copybox',
    props: {
        content: String
    },
    data() { return {
        active: false
    }},
    methods: {
        title() {
            return this.content
        },
        async handleClick() {
            const content = (<HTMLElement>this.$refs['content'])

            const range = document.createRange()
            range.selectNode(content)

            const sel = window.getSelection()
            sel?.removeAllRanges()

            await CopyToClipboard(this.content)
            this.active = true
            setTimeout(() => this.active = false, 400)
            setTimeout(() => {sel?.addRange(range)}, 700)
        }
    }
})
